import React from 'react';
import { WagmiProvider } from 'wagmi';

import { walletWagmiConfig } from './config';

interface WalletProviderProps {
    children: React.ReactNode;
}

const WalletProvider: React.FC<WalletProviderProps> = ({ children }) => (
    <WagmiProvider config={walletWagmiConfig}>{children}</WagmiProvider>
);

WalletProvider.displayName = 'WalletProvider';

export default WalletProvider;
